export default "__VITE_ASSET__c5e0561d__"